import MobileTitleBar from "components/MobileTitleBar"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductCard from "components/Product/ProductCard"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductList from "components/Product/ProductList"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductSearch from "components/Product/ProductSearch"
import ProductSearchExtra from "components/Product/ProductSearchExtra"
import ProductTechnicalTable from "components/Product/ProductTechnicalTable"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import {Col, Row} from "elemental-react16"
import _ from "lodash"
import PropTypes from "prop-types"
import React, {Component} from "react"
import Responsive from "react-responsive"
import {Link} from "react-router-dom"
import {Button, ButtonContent, Card, Container, Icon, Input, Label, Message, Popup, Select, Table} from "semantic-ui-react"
import shop from "shop/shop"
import ButtonLove                                                                     from "components/Button/ButtonLove";
import productStore from "stores/productStore"
import "style/ProductPage.scss"
import settingStore from "../../../stores/settingStore";

let lastProducts = null

const IconImage = ({src, description}) => <Popup content={description}
                                                 trigger={<img className="mr2 icon-product-attribute" width="42"
                                                               src={src} alt=""/>}/>

export default class ProductPage extends Component {

    componentWillUnmount() {
        document.body.classList.remove("no-scroll")
    }

    constructor(props) {
        const {match} = props
        super()
        this.state = {
            id: match.params.productId, product: {}, fullscreenElement: null, variants: false
        }
    }

    loadProduct(id) {
        if (this.id === id) return
        this.id = id
        productStore.get(id)
            .then(product => {
                console.log("ProductPage::product", product)
                product.count = 1
                let inCart = shop.cart.productsById.get(product.map_id)
                if (inCart) product.count = Number(inCart.count)
                shop.analytics.push(product.map_id)
                lastProducts = shop.analytics.lastProducts(4)
                    .filter((id) => id !== product.map_id)
                this.setState({product: product, primaryImage: false})

                if (!product.mainart) return
                productStore.partlist(product.mainart)
                    .then(variants => {

                        // let colors = variants.products.map( product => {
                        //   return {
                        //     color:  product.extras.Farbe,
                        //     map_id: product.map_id
                        //   }
                        // } )

                        let byAttribute = {}
                        variants.variants.varfields.forEach(varfield => {
                            let categories = _.groupBy(variants.products, `extras.${varfield}`)
                            var ordered = {};
                            _(categories).keys().sort().each(function (key) {
                                ordered[key] = categories[key];
                            });
                            byAttribute[varfield] = ordered

                        })
                        this.setState({variants, byAttribute})
                    })
            })
            .catch(err => {
                console.error(`Product not available ${id}`)
                console.error(err)
                this.setState({error: true})
            })
    }

    add = ({product}) => {
        //if ( product.count === 0 ) return shop.cart.remove( product )
        let ok = shop.cart.add(product)
        if (ok) shop.toast(`${product.count * product.unit_multi} Stück ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")

    }

    updateProduct = ({product}) => {
        this.setState({product})
    }

    componentWillReceiveProps({match}) {
        let {productId} = match.params
        this.loadProduct(productId)
    }

    showFullscreen = (element) => {
        this.setState({
            fullscreenElement: element
        })
    }

    setPrimaryImage = (primaryImage) => {
        this.setState({primaryImage})
    }

    componentDidMount() {
        this.loadProduct(this.state.id)
    }

    render() {
        let {fullscreenElement, product, byAttribute, primaryImage, error} = this.state

        if (error) return <div className={"vh-75 tc flex justify-center items-center"}>
            <div>
                <h3>404</h3>
                <div>Produkt nicht gefunden</div>
            </div>
        </div>

        if (!product._type) return null //  duck type check for ProductModel
        let img_srcs = product.img_srcs

        let category = product.cats[0] && product.cats[0] || {}
        let cat_id = category.cat_id

        let productImage
        if (product.img_src) {
            productImage = product.img_src_large
        }

        if (primaryImage) productImage = primaryImage

        // let categoryName = shop.categoryName(product.cats[0].cat_id)
        let path = shop.getCategoryPath(cat_id)

        path.push({
            title: product.title, link: ""
        })


        const veOptions = product.quantities.map(q => {
            return ({
                    key: q.map_desc_id, text: `${q.des} (${q.multi})`, value: q.map_desc_id
                })
        })

        // const veOptions = [
        //   { key: 'all', text: 'All', value: 'all' },
        //   { key: 'articles', text: 'Articles', value: 'articles' },
        //   { key: 'products', text: 'Products', value: 'products' },
        // ]
  
      const mode = settingStore.get( "orderMode" )
      {/*if ( !product.available ) return <Message>
        <div className="tc"> Dieses Produkt ist im Modus {translate( mode )} nicht verfügbar</div>*/
        {/*<pre>{JSON.stringify( product.extras, null, 2 )}</pre>*/}
      /*</Message>*/}

        return (<div className="ProductPageBackground">
<div className="backgroundImageBannerProduct" ></div>
                <MobileTitleBar>
                    <ProductPath path={path} title={product.title} product={product}/>
                </MobileTitleBar>

                <Container className="relative  ">
                    <ProductFullscreen
                        change={this.showFullscreen}
                        images={img_srcs}
                        image={fullscreenElement}/>

                    <Responsive minWidth={790}>
                        <div className="db pb2 pt4">
                            <ProductPath path={path} title={product.title} product={product}/> <br/>
                        </div>
                    </Responsive>

                    {/*<Breadcrumbs path={path}/>*/}
                    <div className="ProductShopCard">
                    <section className="product product-single pb6-ns pb5">
                        <div className="absolute right-2 pr3"><Badge product={product}/></div>
                            <ProductImages
                                key={product.map_id}
                                product={product} images={img_srcs} image={productImage}
                                        onClick={this.showFullscreen}
                                        onClickSecondary={this.setPrimaryImage}/>
                                <TitleSection product={product}/>

                                {/*{shop.session && <ActionSection product={product}*/}
                                {/*onChange={this.updateProduct}*/}
                                {/*onAdd={this.add}/>*/}
                                {/*}*/}

                                {(shop.session && product && product.canBeBought) && <div className="pa3">
                                    <Responsive minWidth={790}>
                                    {shop.session && <div className="product-actions ba b--black-20 pa3 br4 mt4">
                                        {product && <Input style={{border: "none" , height: "45px",}}
                                            type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
                                            this.setState({count: e.target.value})
                                            product.calculate(e.target.value)
                                        }}>
                                            <input className="f4 fw3" style={{border: "none" , height: "45px", width: "100px"}}/>
                                            <Select className="f4 fw3"  style={{border: "none" , height: "45px",}} key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
                                                    onChange={(e, data) => {
                                                        const {value} = data
                                                        const ve = product.quantities.filter(q => q.map_desc_id === value)
                                                        if (!ve) return
                                                        product.unit_multi = ve[0].multi
                                                        product.unit_id = ve[0].map_desc_id
                                                        product.calculate(this.state.count)
                                                        console.log({data, e, value: e.target.value, target: e.target})
                                                        this.setState({count: 1})
                                                    }}
                                            />
                                            <Button style={{border: "none", borderRadius: "10px", width: "80px", height: "45px", backgroundColor: "#5c5c5cff"}} animated="vertical" onClick={() => {
                                                product.count = this.state.count || 1
                                                console.info("BUY", this.state.count, product.unit_multi, product.unit_id)
                                                this.add({product})
                                            }}>       <ButtonContent hidden className="pb1 fw6 white">Shop</ButtonContent>
                                                <ButtonContent visible className="pl2">
                                                    <Icon className="pt1" name="white shop" />
                                                </ButtonContent></Button>

                                        </Input>}
                                        <ButtonLove style={{border:"none"}} list={shop.orderlist.default}
                                                                              circular={false}
                                                                              className="f7 black-20"
                                                                              elementInActive={<Icon style={{border: "none"}} name={"big heart outline"} className="pb1"/>}
                                                                              elementActive={<Icon style={{border: "none"}} name={"big heart"} className="pb1"/>}
                                                                              product={product}/>
                                    </div>}
                                    </Responsive>
                                    <Responsive maxWidth={789}>
                                        <div className="product-actions ba b--black-20 br4 pa3 mt4">
                                            {/*                                        <ButtonLove style={{border:"none"}} list={shop.orderlist.default}
                                            circular={false}
                                            className="f7 black-20 absolut top-1 right-1"
                                            elementInActive={<Icon style={{border: "none"}} name={"big heart outline"} className="pb1"/>}
                                            elementActive={<Icon style={{border: "none"}} name={"big heart"} className="pb1"/>}
                                            product={product}/> */}
                                        {product && <Input style={{border: "none" , height: "45px",}}
                                            type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
                                            this.setState({count: e.target.value})
                                            product.calculate(e.target.value)
                                        }}>
                                            <input className="f4 fw3" style={{border: "none" , height: "45px", width: "70px"}}/>
                                            <Select className="f4 fw3"  style={{border: "none" , height: "45px",}} key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
                                                    onChange={(e, data) => {
                                                        const {value} = data
                                                        const ve = product.quantities.filter(q => q.map_desc_id === value)
                                                        if (!ve) return
                                                        product.unit_multi = ve[0].multi
                                                        product.unit_id = ve[0].map_desc_id
                                                        product.calculate(this.state.count)
                                                        console.log({data, e, value: e.target.value, target: e.target})
                                                        this.setState({count: 1})
                                                    }}
                                            />
                                        </Input>}
                                        <div>
                                                                                        <Button style={{border: "none", borderRadius: "10px", minWidth: "180px", height: "45px", backgroundColor: "#5c5c5cff"}} animated="vertical" onClick={() => {
                                                product.count = this.state.count || 1
                                                console.info("BUY", this.state.count, product.unit_multi, product.unit_id)
                                                this.add({product})
                                            }}>       <ButtonContent hidden className="pb1 fw6 white">Shop</ButtonContent>
                                                <ButtonContent visible className="pl2">
                                                    <Icon className="pt1" name="white shop" />
                                                </ButtonContent></Button>
                                        </div>
                                        </div>
                                    </Responsive>
                                </div>}
                                            
                                {/*<DescriptionSection product={product}/> */}
                                <table className="table-technical mt4">
                                    <colgroup>
                                        <col style={{width: "50%"}}/>
                                        <col style={{width: "50%"}}/>
                                    </colgroup>
                                    <tbody>
                                            <tr>
                                                <Responsive minWidth={790}>
                                                <td>
                                                    {<TechnicalTable product={product}/>}
                                                    
                                                </td>
                                                <td>
                                                    {shop.session && <BulkPricing product={product}/>}
                                                    {/*<TechnicalTable product={product}/>*/}
                                                </td>
                                                </Responsive>
                                                <Responsive maxWidth={789}>
                                                    <td colSpan={2}>
                                                        {<TechnicalTable product={product}/>}
                                                    </td>
                                                </Responsive>
                                            </tr>
                                    </tbody>
                                </table>
                                {/*shop.session && <BulkPricing product={product}/> */}
                                {!shop.session && <div>
                                    <p>
                                        {translate("shop.please_login_for_product_details")}
                                    </p>

                                    <div className="mw6">
                                        <div className="pb2">
                                            <Link to="/login"><Button fluid> {translate("shop.login")}</Button></Link>
                                        </div>
                                        <Link to="/customer_registration"><Button fluid> {translate("shop.register")}</Button></Link>
                                    </div>
                                </div>}
                                {/*shop.session && <ProductTechnicalTable product={product}/> */}
                    </section>
                    </div>
                </Container>

                {product.extras.Kollektion && <div className="bg-silver pv4">
                    <Container>
                        <section className=" pt3 pb5">

                            <div className="cf relative pb3">
                                {product.category.desc && <Link to={`/collection-extra/Kollektion/${product.extras.Kollektion}`}><h2
                                    className="mt2 ttu">{`${translate("Mehr aus Kollektion")}  ${product.extras.Kollektion}`} <Icon
                                    name="chevron right"/></h2>
                                </Link>}
                            </div>

                            <ProductSearchExtra
                                count={4}
                                start={0}
                                extra={"Kollektion"}
                                extraValue={product.extras.Kollektion}
                                query="%%"
                                repeat={ProductCard}/>
                        </section>

                    </Container>
                </div>}

                {product.category && <div className="pv4">
                    <Container>
                        <section className="section-product-slider">
                            <div className="cf relative pb3">
                                {product.category.desc && <Button style={{borderRadius:"35px", minWidth: "250px", minHeight: "40px", fontSize: "1.1rem", fontWeight: "bold", color: "#ffffff"}} primary as={Link} to={`/collection/${product.category.map_id}`}><h2
                                    className="mt2 tt white">{`${translate("Mehr aus")} ${product.category.desc.des || product.category.desc.short_des}`} <Icon name="chevron right"/>
                                </h2>
                                </Button>}
                            </div>

                            <ProductSearch
                                count={4}
                                start={0}
                                cats={[cat_id]}
                                query="%%"
                                repeat={ProductCard}/>
                        </section>
                    </Container>
                </div>}

                <div className="pv4 bg-silver">
                    <Container>
                        {/*Product Slider "last viewed"*/}
                        <section className="section-product-slider pv5">
                            <h2 className="mt2  tt">{translate("Zuletzt angesehen")}</h2>
                            <ProductList
                                count={4}
                                start={0}
                                list={lastProducts}
                                repeat={ProductCard}/>
                        </section>
                    </Container>
                </div>
            </div>)
    }
}

ProductPage.propTypes = {
    price: PropTypes.any
}


const ProductVariant = ({product}) => {
    return (<Card as={Link} to={`/product/${product.map_id}`}>
            <img className="ui image" src={product.img_src_medium}/>
            <div>{product.extras.Art}</div>
            <div>{product.extras.Groesse}</div>
        </Card>)
}

const BulkPricing = ({product}) => {
    if (!product.prices || product.prices.length === 1) return null
    return (

        <div>
            <h4>{translate("Staffelpreise")} </h4>
            <Table>
                <tbody>
                {product.prices.map(price => (<tr key={price.q}>
                        <td>{translate("ab")} {price.q} {translate(product.baseUnitDisplayName)}</td>
                        <td>
                            <div className="tr"><Price>{price.p}</Price></div>
                        </td>
                    </tr>))}
                </tbody>
            </Table>

        </div>)
}

const Fullscreen = ({image, change, images}) => {
    document.body.classList.remove("no-scroll")
    if (!image) {
        return null
    }
    window.scrollTo && window.scrollTo(0, 0)
    const imgs = _.map(images, ({img_src_large, img_src_small}, key) => {
        return (<img key={key}
                     onClick={() => {
                         change(img_src_large)
                     }}
                     className="img-thumbnail "
                     src={img_src_small}/>)
    })

    document.body.classList.add("no-scroll")
    return (<div className="fullscreen">
            <div className="ui pull-right"
                 style={{position: "relative"}}>
                <Button icon="close"
                        basic
                        onClick={() => {
                            change(false)
                        }}/>
            </div>

            <div className="center-child "
                 onClick={() => {
                     change(false)
                 }}>
                <div className="zoom-out img-container">
                    <img src={image} alt=""/>
                </div>
            </div>

            <div className="ui ui-bottom pull-right ">
                <div className="product-images">
                    {imgs}
                </div>
            </div>
        </div>)
}

Fullscreen.propTypes = {
    children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}


const AdditionalTable = ({product}) => {
    return (<section className="AdditionalTable">
            <Row>
                <Col sm="1" md="1" className="pb3">
                    <div className="technischetabelle">
                        <strong>weitere Details</strong>
                        <table className="table-technical">
                            <tbody>
                            {product && shop.session.group !== "WERBE" ? <tr>
                                <td>UVP inkl. MwSt.</td>
                                <td className="text-right"><Price className="fw1">{product.extras.evkpre}</Price></td>
                            </tr> : null}
                            {product && shop.session.group === "WERBE" ? <tr>
                                <td>Industriepreis Netto</td>
                                <td className="text-right"><Price className="fw1">{product.extras.indpre}</Price></td>
                            </tr> : null}
                            {product ? <tr>
                                <td>EAN</td>
                                <td className="text-right">{product.barcode}</td>
                            </tr> : null}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
        </section>)
}

AdditionalTable.propTypes = {
    product: PropTypes.object
}

const TitleSection = ({product}) => (<section className="product-title mb0 pb0">
        <div className="brand">{product.extras.herst !== "unbekannt" && <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>
        <div className="title fw6">{product.desc.short_des}</div>
        <div className=" fw6 pt2 pb2 black-40">{translate("Artikel-Nr.")}: {product.article_nr || product.article_id}</div>

        {product.extras.statusinfo && <Message>{product.extras.statusinfo}</Message>}
        {product.extras.isnew && <Label color={"blue"}>{translate("Achtung Neuheit - nur vorbestellbar")}</Label>}


        {/* Price*/}
        {shop.session && <ProductPrice product={product}/>}

        {product.getNotice()}
        {/* Availability*/}
        {/*shop.config.useAvailability !== false && <Availability product={product}/>*/}
        {/*<Availability product={product}/>*/}
    </section>)

TitleSection.propTypes = {
    product: PropTypes.object
}

const Availability = ({product}) => {
    let notice = product.getNotice()
    return (<div className="availability">
            {notice}
        </div>)
}

const TechnicalTable = ( {product} ) => {
    const mode = settingStore.get( "orderMode" )
    return (
        <div className="pt4">
            {/*<h2 className="bb pb2  f4 fw6 pb4 productDetailsDiv">Produktdetails</h2>*/}
            <Responsive maxWidth={789}>
                         <div className="technicalTableDesktop">
            <table basic="very" className="" >
                <tbody>


                    <tr style={{border:"none"}}>
                        <td style={{border:"none"}}>
                            <label className={" "}>
                                {translate( "Artikel Nr." )}
                            </label>
                        </td>
                        <td style={{border:"none"}}>
                            <b>{product.article_nr}</b>
                        </td>
                    </tr>
                    {product.extras && Object.keys( product.extras ).sort()
                                                       .filter( e => e )
                                                       .filter( e => e !== "Zubehör" )
                                                       .filter( e => !e.startsWith("gefahrgut") )
                                                       .filter( e => !e.startsWith("attr") )
                                                       .filter( e => !e.startsWith("Einkaufspreis") )
                                                       .filter( e => !e.startsWith("Empfehlung") )
                                                       .filter( e => !e.startsWith("Einlagerung") )
                                                       .filter( e => !e.startsWith("Kurzbeschreibung") )
                                                       .filter( e => !e.startsWith("stockText") )
                                                       .filter( e => !e.startsWith("stockColor") )
                                                       .filter( e => !e.startsWith("pluralVE") )
                                                       .filter( e => !e.startsWith("veCount") )
                                                       .map( columnKey => {
                                                         //console.log("columnKey: ", columnKey)
                                                         const valueObject = product.extras[ columnKey ]
                                                         if ( !valueObject ) return null
                                                         if ( !valueObject.value ) return null
                                                         const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
                                                         //console.log("value: ", value)
                                                         return <React.Fragment key={columnKey}>
                                                           <tr style={{border:"none", backgroundColor: "transparent"}}>
                                                             <td style={{border:"none", backgroundColor: "transparent"}}>{valueObject.text == "groesse" ? "Maße" : valueObject.text || translate( columnKey )}</td>
                                                             {value.startsWith(",") &&<td style={{border:"none", backgroundColor: "transparent"}}><b>{value.substring(1,value.length-2) || "Kein Wert"}</b></td>}
                                                             {!value.startsWith(",") && <td style={{border:"none", backgroundColor: "transparent"}}><b>{value || "Kein Wert"}</b></td>}
                                                           </tr>
                                                         </React.Fragment>
                                                       } )}
                    {/*<Table.Row>
                        <Table.Cell>
                            <label className={"fw2 black-60 f5"}>
                                {translate( "UVP" )}
                            </label>
                        </Table.Cell>
                        <Table.Cell>
                            <Price>{mode == 'MODE_PREORDER' ? product.extraValue.uvp_vororder : product.extraValue.uvp}</Price>
                        </Table.Cell>
                </Table.Row>*/}


                    {/*<Table.Row>*/}
                    {/*<Table.Cell>*/}
                    {/*<label className={"fw2 black-60 f5"}>*/}
                    {/*Größe*/}
                    {/*</label>*/}
                    {/*</Table.Cell>*/}
                    {/*<Table.Cell>*/}
                    {/*{product.extras.groesse}*/}
                    {/*</Table.Cell>*/}
                    {/*</Table.Row>*/}



                </tbody>
            </table>
            </div>
                    </Responsive>
                    <Responsive minWidth={790}>
                        <div className="technicalTableDesktop">
            <Table basic="very" className="" >
                <Table.Body>


                    <Table.Row style={{border:"none"}}>
                        <Table.Cell style={{border:"none"}}>
                            <label className={" "}>
                                {translate( "Artikel Nr." )}
                            </label>
                        </Table.Cell>
                        <Table.Cell style={{border:"none"}}>
                            <b>{product.article_nr}</b>
                        </Table.Cell>
                    </Table.Row>
                    {/*shop.session.handId && <Table.Row>
                        <Table.Cell>
                            <label className={" "}>
                                {translate( "Verfügbarkeit" )}
                            </label>
                        </Table.Cell>
                        <Table.Cell>
                            <b>{product.stock}</b>
                        </Table.Cell>
                    </Table.Row>*/}

                    {/*console.log("product.extras: ", product.extras ,Object.keys( product.extras ))*/}
                    {product.extras && Object.keys( product.extras ).sort()
                                                       .filter( e => e )
                                                       .filter( e => e !== "Zubehör" )
                                                       .filter( e => !e.startsWith("gefahrgut") )
                                                       .filter( e => !e.startsWith("attr") )
                                                       .filter( e => !e.startsWith("Einkaufspreis") )
                                                       .filter( e => !e.startsWith("Empfehlung") )
                                                       .filter( e => !e.startsWith("Einlagerung") )
                                                       .filter( e => !e.startsWith("Kurzbeschreibung") )
                                                       .filter( e => !e.startsWith("stockText") )
                                                       .filter( e => !e.startsWith("stockColor") )
                                                       .filter( e => !e.startsWith("pluralVE") )
                                                       .filter( e => !e.startsWith("veCount") )
                                                       .map( columnKey => {
                                                         //console.log("columnKey: ", columnKey)
                                                         const valueObject = product.extras[ columnKey ]
                                                         if ( !valueObject ) return null
                                                         if ( !valueObject.value ) return null
                                                         const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
                                                         //console.log("value: ", value)
                                                         return <React.Fragment key={columnKey}>
                                                           <Table.Row style={{border:"none"}}>
                                                             <Table.Cell style={{border:"none"}}>{valueObject.text == "groesse" ? "Maße" : valueObject.text || translate( columnKey )}</Table.Cell>
                                                             {value.startsWith(",") &&<Table.Cell style={{border:"none"}}><b>{value.substring(1,value.length-2) || "Kein Wert"}</b></Table.Cell>}
                                                             {!value.startsWith(",") && <Table.Cell style={{border:"none"}}><b>{value || "Kein Wert"}</b></Table.Cell>}
                                                           </Table.Row>
                                                         </React.Fragment>
                                                       } )}
                    {/*<Table.Row>
                        <Table.Cell>
                            <label className={"fw2 black-60 f5"}>
                                {translate( "UVP" )}
                            </label>
                        </Table.Cell>
                        <Table.Cell>
                            <Price>{mode == 'MODE_PREORDER' ? product.extraValue.uvp_vororder : product.extraValue.uvp}</Price>
                        </Table.Cell>
                </Table.Row>*/}


                    {/*<Table.Row>*/}
                    {/*<Table.Cell>*/}
                    {/*<label className={"fw2 black-60 f5"}>*/}
                    {/*Größe*/}
                    {/*</label>*/}
                    {/*</Table.Cell>*/}
                    {/*<Table.Cell>*/}
                    {/*{product.extras.groesse}*/}
                    {/*</Table.Cell>*/}
                    {/*</Table.Row>*/}



                </Table.Body>
            </Table>
            </div>
            </Responsive>
        </div>
    )
}

TechnicalTable.propTypes = {
    product: PropTypes.object
}

const ActionSection = ({product, onChange, onAdd}) => {
    if (!product.canBeBought) return null
    const list = shop.orderlist.default
    return (<section className="product-actions pt2 pb4">
            <div style={{display: "inline-block "}}>
                <p>
                    {product.count * product.unit_multi} Stück <Price
                    className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
                <ProductQuantityGroup product={product}
                                      list={list}
                                      showVE={false}
                                      onChange={onChange}
                                      onAdd={onAdd}
                                      large/>
            </div>
        </section>)
}

ActionSection.propTypes = {
    product: PropTypes.object, onChange: PropTypes.func, onAdd: PropTypes.func,
}

const DescriptionSection = ({product}) => (<section className="description pv3 lh-copy">
        {product.desc.des}
    </section>)
DescriptionSection.propTypes = {
    product: PropTypes.object,
}


ProductImages.propTypes = {
    images: PropTypes.any, image: PropTypes.any, onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/ProductPage.js